import React, { useState } from 'react';
import { getSchoolInitials } from '../../utils/schoolTheme';

/**
 * The school's crest. Squared off with a hairline frame rather than a rounded
 * avatar; falls back to a monogram when there is no logo or it fails to load.
 */
const SchoolLogo = ({ schoolName, logoUrl, size = 72, className = '' }) => {
  const [hasFailed, setHasFailed] = useState(false);
  const initials = getSchoolInitials(schoolName) || 'AB';
  const showImage = Boolean(logoUrl) && !hasFailed;

  return (
    <div
      className={`sp-crest ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size / 2.9) }}
    >
      {showImage ? (
        <img
          src={logoUrl}
          alt={`${schoolName} crest`}
          className="sp-crest-image"
          loading="eager"
          decoding="async"
          onError={() => setHasFailed(true)}
        />
      ) : (
        <span className="sp-crest-monogram" aria-hidden="true">
          {initials}
        </span>
      )}

      <style>{`
        .sp-crest {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: #ffffff;
          border: 1px solid var(--sp-rule);
          border-radius: 2px;
        }

        .sp-crest-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 8%;
          box-sizing: border-box;
        }

        .sp-crest-monogram {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: var(--sp-display);
          font-weight: 600;
          letter-spacing: 0.01em;
          color: var(--sp-accent-ink, #1b4e8f);
          background: var(--sp-accent-soft, #eaf1fa);
        }
      `}</style>
    </div>
  );
};

export default SchoolLogo;
